export const GLOBAL_TOP_BAR_HEIGHT = 56
